import React, { useState } from 'react';

import TableComponent from 'components/partials/table-component/table-component';
import EmptySpaceContent from 'components/partials/empty-space-content/empty-space-content';
import Loader from 'components/partials/loader/loader';

import { getCriticalElementsTableSettings } from 'containers/admin/clients/client/tabs-components/critical-elements/critical-elements-table/critical-elements-table-settings';

import Icons from 'assets/icons';

import type { CriticalElement } from 'containers/admin/clients/client/tabs-components/goals-tab/types';

interface SortingParam {
  id: string;
  desc: boolean;
}

interface CriticalElementsTableProps {
  criticalElements: CriticalElement[] | undefined;
  loading: boolean;
  handleViewDetails: (id: string | number) => void;
  clientId: string | number;
  selectedYear: string | number;
}

const CriticalElementsTable = ({
  criticalElements,
  loading,
  handleViewDetails,
  clientId,
  selectedYear,
}: CriticalElementsTableProps): React.JSX.Element => {
  const [sortingParams, setSortingParams] = useState<SortingParam[]>([
    { id: 'summary', desc: false },
  ]);

  const columns = getCriticalElementsTableSettings(
    handleViewDetails,
    clientId,
    selectedYear
  );

  if (loading) {
    return <Loader loading customClass="!bg-white" fullScreen={false} />;
  }

  if (!criticalElements || criticalElements.length === 0) {
    return (
      <EmptySpaceContent
        image={<Icons.EmptyImage customClass="w-[210px] h-[210px]" />}
        text="There are no critical elements to show yet."
      />
    );
  }

  return (
    <div className="border-t border-grey-02">
      <TableComponent
        columns={columns}
        data={criticalElements}
        isLoading={loading}
        sortingParams={sortingParams}
        setSortingParams={setSortingParams}
        customHeight="max-h-[50vh]"
        pagination={false}
      />
    </div>
  );
};

export default CriticalElementsTable;
